// The line under every trader's description field (owner, 2026-10-11).
//
// Since 20261011223741 the server masks phone numbers, emails and messaging
// handles out of a request's text at save: suppliers, the translator and
// every email get the masked copy, and only the admin sees the original. The
// owner chose to mask quietly rather than refuse the save — so the trader is
// told here, before typing, instead of being surprised that their number
// vanished from their own request.
//
// One string in one place, rendered by every form that writes requests
// text: Requests.jsx (direct + managed), RequestWizard.jsx (/request),
// IdeaToProduct.jsx, and the factory RequestQuoteModal.

const NOTE = {
  ar: 'أرقام التواصل والإيميلات وحسابات التواصل تُخفى تلقائيًا عن الموردين — التواصل معهم يتم داخل معبر.',
  en: 'Phone numbers, emails and social handles are hidden from suppliers automatically — you talk to them inside MAABAR.',
  zh: '电话号码、邮箱和社交账号会自动对供应商隐藏 — 与供应商的沟通在 MAABAR 内进行。',
};

export function requestContactNote(lang) {
  return NOTE[lang] || NOTE.en;
}
